import { DeviceOs } from '../realtime/contracts';

const DEVICE_OS_NAMES: Record<DeviceOs, string> = {
  [DeviceOs.Unknown]: 'Unknown',
  [DeviceOs.iOS]: 'iOS',
  [DeviceOs.Android]: 'Android',
  [DeviceOs.WindowsPhone]: 'WindowsPhone',
  [DeviceOs.Aligator]: 'Aligator',
};

export function deviceOsName(deviceOs: DeviceOs): string {
  return DEVICE_OS_NAMES[deviceOs];
}
